import { Injectable, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { FormHolderComponent } from '../components/form-holder/form-holder.component';
import { FormField } from '../models/form-field';
import { IFormField } from '../models/iform-field';
import { TextBoxComponent } from '../components/text-box/text-box.component';

@Injectable()
export class FormBuilderService {

  constructor(private componentFactoryResolver:ComponentFactoryResolver) { }
  loadFormFields(formHolderComponents:FormHolderComponent[],formFields:FormField[]):ComponentRef<any>[]{
    let refs:ComponentRef<any>[]=[];
    formHolderComponents.map((s,i)=>{
      if(formFields[i]){
      let componentFactory= this.componentFactoryResolver.resolveComponentFactory(formFields[i].component);
      s.viewContainerRef.clear();
      let componentRef=s.viewContainerRef.createComponent(componentFactory);
      let formField :IFormField = <IFormField> componentRef.instance;
      formField.label=formFields[i].label;
      formField.id=formFields[i].id;
      formField.data=formFields[i].data;
      formField.validations=formFields[i].validations;
      formField.visibility=formFields[i].visibility;
      formField.isReadOnly=formFields[i].isReadOnly;
      // if(formField instanceof RadioLstComponent && formFields[i].data.change){
      //   let radioLst:RadioLstComponent= <RadioLstComponent> formField;
      //   radioLst.change.subscribe(formFields[i].data.change);
      // }
      // else if(formField instanceof CheckBoxComponent && formFields[i].data.change){
      //   let checkLst:CheckBoxComponent= <CheckBoxComponent> formField;
      //   checkLst.change.subscribe(formFields[i].data.change);
      // }
      // else 
      // if(formField instanceof SelectBoxComponent && formFields[i].data.change){
      //   let checkLst:SelectBoxComponent= <SelectBoxComponent> formField;
      //   checkLst.change.subscribe(formFields[i].data.change);
      // }
      // else if(formField instanceof TextBoxComponent && formFields[i].data.change){
      //   let checkLst:TextBoxComponent= <TextBoxComponent> formField;
      //   checkLst.change.subscribe(formFields[i].data.change);
      // }
      
      refs.push(componentRef);
    }
    });
    return refs;
  }
  validateFields(refs:ComponentRef<any>[]):Boolean{
    //formFields.map(f=>f.data["validate"]=true);
    let valid=true;
    refs.map(f=>{
      let formField:IFormField= <IFormField> f.instance;
      if(!formField.checkValidity())
        valid=false;
    })
    return valid;
  }
}
